export default __webpack_public_path__ + "static/media/password-img@2x.86e20a4f.png";